import createReducer from '../createReducer';
import {
  GET_TEAMS_AND_USERS,
  GET_TEAMS_AND_USERS_SUCCESS,
  GET_TEAMS_AND_USERS_FAIL,
  SAVE_USERS_TEAMS,
  SAVE_USERS_TEAMS_SUCCESS,
  SAVE_USERS_TEAMS_FAIL,
  UPDATE_USERS_ACCESSES,
  UPDATE_USERS_ACCESSES_SUCCESS,
  UPDATE_USERS_ACCESSES_FAIL,
  GET_HWR_USERS,
  GET_HWR_USERS_SUCCESS,
  GET_HWR_USERS_FAIL,
  DELETE_HWR_USER,
  DELETE_HWR_USER_SUCCESS,
  DELETE_HWR_USER_FAIL,
  UPDATE_FLM,
  UPDATE_FLM_SUCCESS,
  UPDATE_FLM_FAIL,
  CREATE_HWR_USER,
  CREATE_HWR_USER_SUCCESS,
  CREATE_HWR_USER_FAIL,
  UPDATE_HWR_USER,
  UPDATE_HWR_USER_SUCCESS,
  UPDATE_HWR_USER_FAIL,
} from '../actions/admin';

export const initialState = {
  teams: [],
  usersWithRoles: [],
  loading: false,
  saving: false,
  savingFlm: false,
  hwrUsers: [],
  loadingHWRUsers: false,
};

export default createReducer(initialState, {
  [GET_TEAMS_AND_USERS]: draft => {
    draft.loading = true;
  },

  [GET_TEAMS_AND_USERS_SUCCESS]: (draft, action) => {
    draft.loading = false;
    draft.teams = action.teams;
    draft.usersWithRoles = action.usersWithRoles;
  },

  [GET_TEAMS_AND_USERS_FAIL]: draft => {
    draft.loading = false;
  },

  [SAVE_USERS_TEAMS]: draft => {
    draft.saving = true;
  },

  [SAVE_USERS_TEAMS_SUCCESS]: (draft, action) => {
    draft.saving = false;
    draft.usersWithRoles = action.usersWithRoles;
  },

  [SAVE_USERS_TEAMS_FAIL]: draft => {
    draft.saving = false;
  },

  [UPDATE_USERS_ACCESSES]: draft => {
    draft.saving = true;
  },

  [UPDATE_USERS_ACCESSES_SUCCESS]: (draft, action) => {
    draft.saving = false;
    draft.usersWithRoles = action.usersWithRoles;
  },

  [UPDATE_USERS_ACCESSES_FAIL]: draft => {
    draft.saving = false;
  },

  [GET_HWR_USERS]: draft => {
    draft.loadingHWRUsers = true;
  },

  [GET_HWR_USERS_SUCCESS]: (draft, action) => {
    draft.loadingHWRUsers = false;
    draft.hwrUsers = action.hwrUsers;
  },

  [GET_HWR_USERS_FAIL]: draft => {
    draft.loadingHWRUsers = false;
  },

  [DELETE_HWR_USER]: draft => {
    draft.saving = true;
  },

  [DELETE_HWR_USER_SUCCESS]: (draft, action) => {
    draft.saving = false;
    draft.hwrUsers = draft.hwrUsers.filter(user => user.id !== action.userId);
  },

  [DELETE_HWR_USER_FAIL]: draft => {
    draft.saving = false;
  },

  [CREATE_HWR_USER]: draft => {
    draft.saving = true;
  },

  [CREATE_HWR_USER_SUCCESS]: (draft, action) => {
    draft.saving = false;
    draft.hwrUsers = [...draft.hwrUsers, action.newUser];
  },

  [CREATE_HWR_USER_FAIL]: draft => {
    draft.saving = false;
  },

  [UPDATE_HWR_USER]: draft => {
    draft.saving = true;
  },

  [UPDATE_HWR_USER_SUCCESS]: (draft, action) => {
    draft.saving = false;
    draft.hwrUsers = draft.hwrUsers.map(user => (user.id == action.userData.id ? action.userData : user));
  },

  [UPDATE_HWR_USER_FAIL]: draft => {
    draft.saving = false;
  },

  [UPDATE_FLM]: draft => {
    draft.savingFlm = true;
  },

  [UPDATE_FLM_SUCCESS]: draft => {
    draft.savingFlm = false;
  },

  [UPDATE_FLM_FAIL]: draft => {
    draft.savingFlm = false;
  },
});
